import { bool, shape, string } from 'prop-types'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { positionPropType } from '../common/position-prop-type'
import { locationDescriptionBasePropType } from './location-description-base-prop-type'

/**
 * @typedef {Object} Door
 * @property {string} doorCode
 * @property {string} doorConfigId
 * @property {string} doorStatusId
 * @property {string} name
 * @property {bool} isOpen
 * @property {ISO8601} start
 * @property {ISO8601} [end]
 * @property {object} [startLocation]
 * @property {LocationDescriptionBase} [startLocation.locationDescription]
 * @property {Position} [startLocation.position]
 * @property {object} [endLocation]
 * @property {LocationDescriptionBase} [endLocation.locationDescription]
 * @property {Position} [endLocation.position]
 */

export const doorPropType = shape({
    doorCode: string.isRequired,
    doorConfigId: string.isRequired,
    doorStatusId: string.isRequired,
    name: string.isRequired,
    isOpen: bool.isRequired,
    start: iso8601PropType.isRequired,
    end: iso8601PropType,
    startLocation: shape({
        locationDescription: locationDescriptionBasePropType,
        position: positionPropType
    }),
    endLocation: shape({
        locationDescription: locationDescriptionBasePropType,
        position: positionPropType
    })
})
